import Vue from 'vue'
import { STATE_ABORTED, STATE_PENDING } from '../../../constants'

export default {
  setEmailTemplates (state, { emailTemplates }) {
    state.emailTemplates = emailTemplates
  },

  updateEmailTemplate (state, { id, emailTemplate }) {
    let template = state.emailTemplates.find(tmp => tmp.id === id)
    if (template) {
      Object.assign(template, emailTemplate)
    }
  },

  setNewsletters (state, { newsletters }) {
    state.newsletters = newsletters
  },

  createNewsletter (state, { newsletter }) {
    state.newsletters.push(newsletter)
  },

  updateNewsletter (state, { id, newsletter }) {
    const oldNewsletter = state.newsletters.find(letter => letter.id === id)
    if (oldNewsletter) {
      Object.assign(oldNewsletter, newsletter)
    }
  },

  dispatchNewsletter (state, id) {
    let newsletter = state.newsletters.find(letter => letter.id === id)
    if (newsletter) {
      Vue.set(newsletter, 'state', STATE_PENDING)
    }
  },

  abortNewsletter (state, id) {
    let newsletter = state.newsletters.find(letter => letter.id === id)
    if (newsletter) {
      Vue.set(newsletter, 'state', STATE_ABORTED)
    }
  },

  deleteNewsletter (state, id) {
    state.newsletters = state.newsletters.filter(newsletter => newsletter.id !== id)
  },

  setHolidays (state, { holidays }) {
    state.holidays = holidays
  },

  setSelectedHolidayYear (state, { year }) {
    state.selectedHolidayYear = year
  },

  createHoliday (state, { holiday }) {
    state.holidays.push(holiday)
  },

  deleteHoliday (state, { date }) {
    state.holidays = state.holidays.filter(holiday => holiday.date !== date)
  },

  setUsers (state, { users }) {
    state.users = users
  },

  deleteUser (state, { id }) {
    state.users = state.users.filter(user => user.id !== id)
  },

  setUnModeratedAdverts (state, { adverts }) {
    state.unModeratedAdverts = adverts
  },

  deleteUnModeratedAdvert (state, { id }) {
    state.unModeratedAdverts = state.unModeratedAdverts.filter(advert => advert.id !== id)
  },

  flagAdvert (state, { id }) {
    const advert = state.unModeratedAdverts.find(ad => ad.id === id)
    if (advert) {
      Vue.set(advert, 'reqOversee', true)
    }
  },

  setUnModeratedBidCards (state, { bidCards }) {
    state.unModeratedBidCards = bidCards
  },

  deleteUnModeratedBidCard (state, { id }) {
    state.unModeratedBidCards = state.unModeratedBidCards.filter(bidCard => bidCard.id !== id)
  },

  flagBidCard (state, { id }) {
    const bidCard = state.unModeratedBidCards.find(bidCard => bidCard.id === id)
    if (bidCard) {
      Vue.set(bidCard, 'reqOversee', true)
    }
  },

  setUnModeratedEmployerSearches (state, { searches }) {
    state.unModeratedEmployerSearches = searches
  },

  removeEmployerSearchOccupation (state, { name }) {
    state.unModeratedEmployerSearches = state.unModeratedEmployerSearches.filter(occupation => occupation.name !== name)
  },

  setUnModeratedOccupations (state, { occupations }) {
    state.unModeratedOccupations = occupations
  },

  removeOccupation (state, { id }) {
    state.unModeratedOccupations = state.unModeratedOccupations.filter(occupation => occupation.id !== id)
  },

  reset (state) {
    state.emailTemplates = []
    state.holidays = []
    state.newsletters = []
    state.selectedHolidayYear = null
    state.unModeratedAdverts = []
    state.unModeratedEmployerSearches = []
    state.unModeratedOccupations = []
    state.users = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/mutations.js